import { Box } from "@chakra-ui/react";

import MobileCartItem from "./mobileCartItem";

export default function Index({ cart }) {
  return (
    <Box
      flexDirection="column"
      d={{ base: "flex", md: "none" }}
      width={{ base: "100%", xl: "80%" }}
    >
      {cart.map((product) => (
        <MobileCartItem key={product.id} product={product} />
      ))}
    </Box>
  );
}
